/* Eliza cart: the live (Impulse) cart drawer and cart page behaviour on Dawn.
   <cart-drawer> keeps Dawn's contract for product-form.js: getSectionsToRender(), renderContents(),
   setActiveElement(), open(). Quantity +/-, typed quantity and remove update through /cart/change.js and
   re-render the drawer, the header bubble and (on /cart) the cart page section.
   Also records and renders "Recently viewed" (localStorage 'theme-recent', same format as live). */
(function () {
  const html = document.documentElement;
  const parse = (text) => new DOMParser().parseFromString(text, 'text/html');

  class CartDrawer extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      document.addEventListener('click', (e) => {
        const opener = e.target.closest('.js-drawer-open-cart, #cart-icon-bubble');
        if (opener && !e.defaultPrevented) {
          e.preventDefault();
          this.setActiveElement(opener);
          this.open();
          return;
        }
        if (e.target.closest('#CartDrawer .js-drawer-close')) { this.close(); return; }
        if (this.classList.contains('drawer--is-open') && !this.contains(e.target) && !e.target.closest('.js-quick-view')) this.close();
      });
      document.addEventListener('keyup', (e) => { if (e.key === 'Escape') this.close(); });
      bindQuantity(this);
    }

    open() {
      if (this.classList.contains('drawer--is-open')) return;
      this.classList.add('is-transitioning');
      void this.offsetWidth;
      this.classList.add('drawer--is-open');
      html.classList.add('js-drawer-open', 'js-drawer-open-right');
    }

    close() {
      if (!this.classList.contains('drawer--is-open')) return;
      this.classList.remove('drawer--is-open');
      html.classList.remove('js-drawer-open', 'js-drawer-open-right');
      setTimeout(() => { if (!this.classList.contains('drawer--is-open')) this.classList.remove('is-transitioning'); }, 450);
      if (this.activeElement && this.activeElement.focus) this.activeElement.focus({ preventScroll: true });
    }

    setActiveElement(el) { this.activeElement = el; }

    getSectionsToRender() {
      const list = [{ id: 'cart-drawer', selector: '#CartDrawer' }, { id: 'cart-icon-bubble' }];
      const page = document.querySelector('[data-el-cart-page]');
      if (page) list.push({ id: page.dataset.section, selector: '[data-el-cart-page]' });
      return list;
    }

    renderContents(state) {
      renderSections(state.sections || {}, this.getSectionsToRender());
      setTimeout(() => this.open());
    }
  }

  function renderSections(sections, list) {
    list.forEach((s) => {
      const src = sections[s.id];
      if (!src) return;
      const doc = parse(src);
      if (s.id === 'cart-icon-bubble') {
        const target = document.getElementById('cart-icon-bubble');
        const from = doc.querySelector('.shopify-section');
        if (target && from) target.innerHTML = from.innerHTML;
        return;
      }
      const target = document.querySelector(s.selector);
      const from = doc.querySelector(s.selector);
      if (!target || !from) return;
      target.innerHTML = from.innerHTML;
      if (target.tagName === 'CART-DRAWER') target.classList.toggle('is-empty', from.classList.contains('is-empty'));
    });
  }

  let busy = false;
  async function changeLine(key, quantity, root) {
    if (busy) return;
    busy = true;
    const wrapper = root && root.querySelector(`.cart__item[data-key="${CSS.escape(key)}"] .js-qty__wrapper`);
    if (wrapper) wrapper.classList.add('is-loading');
    const drawer = document.querySelector('cart-drawer');
    const list = drawer ? drawer.getSectionsToRender() : [{ id: 'cart-icon-bubble' }];
    try {
      const res = await fetch(`${window.routes.cart_change_url}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity, sections: list.map((s) => s.id), sections_url: window.location.pathname }),
      });
      const state = await res.json();
      if (state.sections) renderSections(state.sections, list);
      if (typeof publish === 'function' && window.PUB_SUB_EVENTS) publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: state });
      if (document.querySelector('[data-el-cart-page]') && state.item_count === 0) window.location.reload();
    } catch (e) {
      if (wrapper) wrapper.classList.remove('is-loading');
    }
    busy = false;
  }

  /* +/- buttons, typed quantities and remove links, for any cart form (drawer or page) */
  function bindQuantity(root) {
    if (root.dataset.qtyBound) return;
    root.dataset.qtyBound = '1';
    root.addEventListener('click', (e) => {
      const btn = e.target.closest('.js-qty__adjust');
      if (btn) {
        e.preventDefault();
        const input = btn.closest('.js-qty__wrapper').querySelector('.js-qty__num');
        let qty = parseInt(input.value, 10) || 0;
        qty = btn.classList.contains('js-qty__adjust--plus') ? qty + 1 : Math.max(0, qty - 1);
        input.value = qty;
        changeLine(input.dataset.id, qty, root);
        return;
      }
      const rm = e.target.closest('.js-cart-remove');
      if (rm) {
        e.preventDefault();
        changeLine(rm.dataset.id, 0, root);
      }
    });
    root.addEventListener('change', (e) => {
      const input = e.target.closest('.js-qty__num');
      if (!input) return;
      const qty = parseInt(input.value, 10);
      if (!isNaN(qty) && qty >= 0) changeLine(input.dataset.id, qty, root);
    });
  }

  if (!customElements.get('cart-drawer')) customElements.define('cart-drawer', CartDrawer);

  /* recently viewed */
  const KEY = 'theme-recent';
  const readRecent = () => { try { return JSON.parse(localStorage.getItem(KEY)) || {}; } catch (e) { return {}; } };
  const m = window.location.pathname.match(/\/products\/([^/?#]+)/);
  if (m) {
    try {
      const handle = decodeURIComponent(m[1]);
      const recent = readRecent();
      const prev = recent[handle] || {};
      delete recent[handle];
      recent[handle] = { url: '/products/' + handle, aspectRatio: prev.aspectRatio, featuredImage: prev.featuredImage };
      localStorage.setItem(KEY, JSON.stringify(recent));
    } catch (e) { /* storage unavailable */ }
  }

  const esc = (s) => String(s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  const imgUrl = (src, w) => src ? src + (src.includes('?') ? '&' : '?') + 'width=' + w : '';

  async function renderRecent(container) {
    const recent = readRecent();
    const handles = Object.keys(recent).filter((h) => h && h !== 'undefined');
    if (!handles.length) return;
    const get = (h, tries = 2) => fetch(`/products/${h}.js`)
      .then((r) => (r.ok ? r.json() : r.status === 429 && tries > 1 ? new Promise((ok) => setTimeout(() => ok(get(h, tries - 1)), 1500)) : null))
      .catch(() => null);
    const products = await Promise.all(handles.map((h) => get(h)));
    const limit = parseInt(container.dataset.recentCount, 10) || 5;
    const current = container.dataset.productHandle;
    const items = [];
    products.forEach((p) => {
      if (!p || !p.handle || p.handle === current) return;
      items.unshift(p);
    });
    if (!items.length) return;
    const width = container.dataset.gridItemClass;
    container.querySelector('.grid').innerHTML = items.slice(0, limit).map((p) => {
      const img = p.featured_image ? (p.featured_image.startsWith('//') ? 'https:' + p.featured_image : p.featured_image) : '';
      const url = (recent[p.handle] && recent[p.handle].url) || p.url;
      return `
        <div class="grid__item grid-product ${width}">
          <div class="grid-product__content">
            <a href="${esc(url)}" class="grid-product__link">
              <div class="grid-product__image-mask">
                <div class="grid__image-ratio grid__image-ratio--portrait">
                  ${img ? `<img src="${esc(imgUrl(img, 720))}" srcset="${[360, 540, 720, 900, 1080].map((w) => esc(imgUrl(img, w)) + ' ' + w + 'w').join(', ')}" sizes="(min-width: 769px) 20vw, 39vw" alt="${esc(p.title)}" loading="lazy">` : ''}
                </div>
              </div>
              <div class="grid-product__meta">
                <div class="grid-product__title">${esc(p.title)}</div>
              </div>
            </a>
          </div>
        </div>`;
    }).join('');
    container.classList.remove('hide');
  }

  const ready = () => {
    document.querySelectorAll('[data-el-cart-page]').forEach(bindQuantity);
    document.querySelectorAll('[data-el-recently-viewed]').forEach((c) => renderRecent(c));
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready);
  else ready();
})();
